import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import { formatWorkerDocumentList } from './worker-document.helper';
import { WorkerDocumentActions } from './worker-document.redux';
import {
	IPayloadDeleteWorkerDocumentRequest,
	IPayloadGetWorkerDocumentListRequest,
	IPayloadUpdateDocumentRequest,
	IPayloadWorkerDocumentDetailRequest,
} from './worker-document.type';

export function* getWorkerDocumentList(
	action: PayloadAction<IPayloadGetWorkerDocumentListRequest>
) {
	const { callback, searchTypes, ...rest } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetWorkerDocumentListResponse> =
			yield API.getWorkerDocumentList({ searchTypes, ...rest });
		const data = formatWorkerDocumentList(res.data);

		yield put(
			WorkerDocumentActions.getWorkerDocumentListSuccess({
				...rest,
				content: data.content,
				total: data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerDocumentActions.getWorkerDocumentListFailure());
	}
}

export function* deleteWorkerDocument(
	action: PayloadAction<IPayloadDeleteWorkerDocumentRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.deleteWorkerDocument(ids);

		yield put(WorkerDocumentActions.deleteWorkerDocumentSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerDocumentActions.deleteWorkerDocumentFailure());
	}
}

export function* getWorkerDocumentDetail(
	action: PayloadAction<IPayloadWorkerDocumentDetailRequest>
) {
	const { callback, id } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.TDocumentDefineItem> =
			yield API.getWorkerDocumentDetail(id);

		yield put(
			WorkerDocumentActions.getWorkerDocumentDetailSuccess({
				documentDetail: res?.data,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerDocumentActions.getWorkerDocumentDetailFailure());
	}
}

export function* updateWorkerDocument(
	action: PayloadAction<IPayloadUpdateDocumentRequest>
) {
	const { callback, id, data } = action.payload;

	try {
		yield API.updateWorkerDocumentItem(id, data);

		yield put(WorkerDocumentActions.updateDocumentSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerDocumentActions.updateDocumentFailure());
	}
}
